import { z } from "zod";
import { ValidationError } from "../errors/ValidationError";
import { dispatchValidationError } from "../errors/errorDispatcher";

const emptyStringOrNull = z.union([z.literal(""), z.string()]).nullable().optional();

const positiveIntSchema = z
  .union([z.number().int().positive(), z.string().regex(/^\d+$/)])
  .transform((v) => (typeof v === "string" ? Number(v) : v))
  .refine((v) => Number.isInteger(v) && v > 0, { message: "must be a positive integer" });

export const storiciRequestSchema = z.object({
  vendorListId: positiveIntSchema,
  catalogoId: positiveIntSchema,
  startDate: emptyStringOrNull,
  endDate: emptyStringOrNull,
  token: z.string().optional().nullable(),
});

export const catalogClickStatsRequestSchema = z.object({
  catalogListId: positiveIntSchema,
  nome: z.string().optional().nullable(),
});

export function validateCatalogClickStatsRequest(data) {
  const parsed = catalogClickStatsRequestSchema.safeParse(data);
  if (!parsed.success) {
    const message = `Invalid catalog click stats payload: ${parsed.error.issues[0]?.message ?? "unknown error"}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}

export function validateStoriciRequest(data) {
  const parsed = storiciRequestSchema.safeParse(data);
  if (!parsed.success) {
    const message = `Invalid storici payload: ${parsed.error.issues[0]?.message ?? "unknown error"}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}

